/* YORU Y2K: marquee, sparkles, cursor trail */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function buildMarquee() {
    var msg = document.querySelector('.announcement-bar__message');
    if (!msg || msg.dataset.y2k) return;
    msg.dataset.y2k = '1';
    var text = (msg.textContent || '').trim();
    var items = [text, '夜 YORU VOL. 1', text, 'JAPANESE STREETWEAR'];
    var wrap = document.createElement('div');
    wrap.className = 'y2k-marquee';
    var track = document.createElement('div');
    track.className = 'y2k-marquee__track';
    for (var r = 0; r < 4; r++) {
      items.forEach(function (t) {
        var s = document.createElement('span');
        s.textContent = '✦ ' + t;
        if (r > 0) s.setAttribute('aria-hidden', 'true');
        track.appendChild(s);
      });
    }
    wrap.appendChild(track);
    msg.textContent = '';
    msg.appendChild(wrap);
  }

  function buildSparkles() {
    if (reduceMotion || document.querySelector('.y2k-sparkles')) return;
    var layer = document.createElement('div');
    layer.className = 'y2k-sparkles';
    layer.setAttribute('aria-hidden', 'true');
    var glyphs = ['✦', '✧', '★', '✶'];
    var count = window.innerWidth < 750 ? 10 : 22;
    for (var i = 0; i < count; i++) {
      var s = document.createElement('span');
      s.textContent = glyphs[i % glyphs.length];
      s.style.left = Math.random() * 100 + '%';
      s.style.top = Math.random() * 100 + '%';
      s.style.animationDelay = (Math.random() * 4.5).toFixed(2) + 's';
      s.style.animationDuration = (3.5 + Math.random() * 3).toFixed(2) + 's';
      layer.appendChild(s);
    }
    document.body.appendChild(layer);
  }

  function cursorTrail() {
    if (reduceMotion || !window.matchMedia('(hover: hover)').matches) return;
    var last = 0;
    var colors = ['#ff2e92', '#7fd4ff', '#c9b6ff'];
    document.addEventListener('mousemove', function (e) {
      var now = Date.now();
      if (now - last < 60) return;
      last = now;
      var s = document.createElement('span');
      s.className = 'y2k-trail';
      s.setAttribute('aria-hidden', 'true');
      s.textContent = '✦';
      s.style.left = e.clientX + 'px';
      s.style.top = e.clientY + 'px';
      s.style.color = colors[Math.floor(Math.random() * colors.length)];
      document.body.appendChild(s);
      setTimeout(function () { s.remove(); }, 800);
    }, { passive: true });
  }

  function init() { buildMarquee(); buildSparkles(); cursorTrail(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', buildMarquee);
})();
